import React, {useContext} from 'react';
import Row from 'react-bootstrap/Row';
import { LabelText } from '../../components/Language';
import HeaderTitle from '../../hoc/HeaderTitle';
import {ChangeRequestContext} from '../context/ChangeRequestProvider';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import './index.css';

function ChangeRequestOverviewHeader(props) {  

  const {  isCrFilterApplied, handlerOnClearFilterClick  } = useContext(ChangeRequestContext);

  const clearFilterTooltip = (
    <Tooltip id="clearFilterIcon">
      <LabelText tid={isCrFilterApplied ? "clearfilter" : "inactivefilter"} />
    </Tooltip>
  )

    return ( 
      <div>       
      <HeaderTitle className = "change-request-overview-header-code-row row">
        <span className="change-request-overview-header-title-align">
          <LabelText tid="cr_overview" />
        </span>
        <span className="change-request-overview-header-code-align">
          {props.BusinessPartnerCode}
        </span>
      </HeaderTitle>
      <Row className="change-request-overview-btn-row">
      <div className="empty-div"/>
      <OverlayTrigger placement="top" overlay={clearFilterTooltip}>
          <div role="button" tabIndex="0" title= {isCrFilterApplied ? "Clear filter" : "Inactive Filter"}              
               disabled={!props.isCrOverviewDetails} onClick={()=>isCrFilterApplied
                 && handlerOnClearFilterClick(true)}
               onKeyDown={(e) => { e.key === "Enter" 
               && isCrFilterApplied && handlerOnClearFilterClick(true)}} >
              <FontAwesomeIcon className = { props.isCrOverviewDetails ?
               isCrFilterApplied ? "FilterButton ActiveFilterButtonSubmitted" : "FilterButton InActiveFilterButtonUnSubmitted"
              : "FilterButton InActiveFilterButton disable-icon"
                    } icon= {faFilter} />
          </div>
        </OverlayTrigger>
        </Row> 
      </div>
              
    )
}

export default ChangeRequestOverviewHeader;